import { defineMessages } from 'react-intl-next';

export default defineMessages({
  titleText: {
    id: 'component-card-search-list.error-state.permissions-error.title.non-final',
    defaultMessage: 'You don’t have access',
    description: 'Error state card title',
  },
  descriptionText: {
    id: 'component-card-search-list.error-state.permissions-error.description.non-final',
    defaultMessage:
      'To bring more context to your code, ask your admin to give you access to Compass.',
    description: 'Error state card description',
  },
  requestAccess: {
    id: 'component-card-search-list.error-state.permissions-error.link-compass-component.non-final',
    defaultMessage: 'Request access',
    description: 'Text for link to request access to Compass',
  },
  learnMore: {
    id: 'component-card-search-list.error-state.permissions-error.learn-more.non-final',
    defaultMessage: 'Learn more',
    description: 'Text for links to documentation',
  },
});
